let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gWkdY")).then(() => parcelRequire('8Kw2Q'));